import { render, staticRenderFns } from "./UserQrCodeFailurePage.vue?vue&type=template&id=2c752733&scoped=true"
import script from "./UserQrCodeFailurePage.vue?vue&type=script&lang=js"
export * from "./UserQrCodeFailurePage.vue?vue&type=script&lang=js"
import style0 from "./UserQrCodeFailurePage.vue?vue&type=style&index=0&id=2c752733&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c752733",
  null
  
)

export default component.exports